import { ScrollCaptain } from 'scroll-captain';

class Bento {
    constructor(element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-research-ai-landingpage-bento',
            innerValue: 'inner',
            speedValue: 'speed-',
            tagsValue: 'tags',
            circleDiagramValue: 'circle-diagram',
            barChart1Value: 'bar-chart-1',
            barChart2Value: 'bar-chart-2',
            speechbubbleValue: 'speechbubble',
            chartValue: 'chart',
            graphic1Trigger: 'graphic-1-trigger',
            graphic2Trigger: 'graphic-2-trigger',
            graphic3Trigger: 'graphic-3-trigger',
            tagTriggerValue: 'tag-trigger',
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);
        this.speedBlockAnimation = null;
        this.diagram1Animation = null;
        this.diagram2Animation = null;
        this.diagram3Animation = null;
        this.tagAnimation = null;

        // Elements
        this.$bento = element;
        this.$$speedBlocks = this.$bento.querySelectorAll(`[${ this.settings.initAttr }^="${ this.settings.speedValue }"]`);
    }

    initialize() {
        if (this.$$speedBlocks.length > 0 && window.innerWidth >= 768) {
            this.initSpeedBlockAnimation();
            this.initDiagram1Animation();
            this.initDiagram2Animation();
            this.initDiagram3Animation();
            this.initTagAnimation();
        }
    }

    initDiagram1Animation() {
        this.diagram1Animation = new ScrollCaptain(this.$bento, {
            initAttr: this.settings.initAttr,
            triggerSuffix: this.settings.graphic1Trigger,
            bottom: '-20%',
            animateBarChart: {
                targetSuffix: this.settings.barChart1Value,
                class: 'is-animated',
                resetOnScrollDown: false,
                resetOnScrollUp: false,
            },
        });
    }

    initDiagram2Animation() {
        this.diagram2Animation = new ScrollCaptain(this.$bento, {
            initAttr: this.settings.initAttr,
            triggerSuffix: this.settings.graphic2Trigger,
            bottom: '-20%',
            animateBarChart: {
                targetSuffix: this.settings.circleDiagramValue,
                class: 'is-animated',
                resetOnScrollDown: false,
                resetOnScrollUp: false,
            },
        });
    }

    initDiagram3Animation() {
        this.diagram3Animation = new ScrollCaptain(this.$bento, {
            initAttr: this.settings.initAttr,
            triggerSuffix: this.settings.graphic3Trigger,
            bottom: '-20%',
            animateBarChart: {
                targetSuffix: this.settings.barChart2Value,
                class: 'is-animated',
                resetOnScrollDown: false,
                resetOnScrollUp: false,
            },
        });
    }

    initTagAnimation() {
        this.tagAnimation = new ScrollCaptain(this.$bento, {
            triggerSuffix: this.settings.tagTriggerValue,
            initAttr: this.settings.initAttr,
            bottom: '-40%',
            animateTags: {
                targetSuffix: this.settings.tagsValue,
                class: 'is-animated',
                resetOnScrollDown: false,
                resetOnScrollUp: false,
            },
        });
    }

    initSpeedBlockAnimation() {
        const speedAnimations = {};

        const defaultOptions = {
            onscroll: true,
            duration: 0,
            easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
        };

        this.$$speedBlocks.forEach(($speedBlock, index) => {
            speedAnimations[`animateSpeed${ index + 1 }`] = {
                ...defaultOptions,
                targetSuffix: `${ this.settings.speedValue }${ index + 1 }`,
                translateY: { 0: 20 * (index + 1) * 2, 100: 20 * (index + 1) * -2 },
            };
        });

        this.speedBlockAnimation = new ScrollCaptain(this.$bento, {
            initAttr: this.settings.initAttr,
            animateSpeechbubble: {
                targetSuffix: this.settings.speechbubbleValue,
                ...defaultOptions,
                translateX: { 0: -80, 100: 80 },
            },
            ...speedAnimations,
        });
    }
}

export { Bento };
